import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

interface GrecaptchaEnterprise {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options?: any) => Promise<string>;
  reset: () => void;
}

declare global {
  interface Window {
    grecaptcha: {
      enterprise: GrecaptchaEnterprise;
      reset: () => void;
    };
  }
}

const grecaptcha = window.grecaptcha;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor() { }


  public resetRecaptcha() {
    grecaptcha.reset();
  }

  /**
   * Retrieves the reCAPTCHA response token using Google's reCAPTCHA Enterprise API.
   *
   * This method initializes the reCAPTCHA Enterprise library and executes the reCAPTCHA
   * challenge using the provided site key. If the execution is successful, it resolves
   * with the response token. If an error occurs during execution, it logs the error
   * and resolves with `null`.
   *
   * @returns {Promise<string | null>} A promise that resolves to the reCAPTCHA response token
   * or `null` if an error occurs.
   */
   public getRecaptchaResponse(): Promise<string | null> {
    return new Promise((resolve) => {
      if (!grecaptcha?.enterprise) {
        console.error('reCAPTCHA no está disponible.');
        resolve(null);
        return;
      }

      grecaptcha.enterprise.ready(async () => {
        try {
          const response = await window.grecaptcha.enterprise.execute(environment.recaptchaSiteKey);
          resolve(response);
        } catch (error) {
          console.error('Error ejecutando reCAPTCHA:', error);
          resolve(null);
        }
      });
    });
  }

}
